import { Auth } from 'aws-amplify';

const awsconfig = {
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'us-west-2',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,
    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    // cookieStorage: {
    // // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //     domain: '.yourdomain.com',
    // // OPTIONAL - Cookie path
    //     path: '/',
    // // OPTIONAL - Cookie expiration in days
    //     expires: 365,
    // // OPTIONAL - Cookie secure flag
    // // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //     secure: true
    // },
    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: process.env.VUE_APP_COGNITO_APP_DOMAIN,
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: process.env.VUE_APP_COGNITO_REDIRECT_URI,
      redirectSignOut: process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT,
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: process.env.VUE_APP_API_ENDPOINT,
        custom_header: async () => { 
          return {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          };
        },
      },
    ],
  },
};

if (process.env.NODE_ENV === 'development') {
  awsconfig.API.endpoints[0].endpoint = 'http://localhost:3000';
}

export default awsconfig;